export const MAX_RECENT_FILES = 20
export const MAX_RECENT_FILES_TO_SHOW = 6
export const RECENT_FILES_STORAGE_KEY_ADMIN = 'ciq_admin_recent_files'
export const RECENT_FILES_STORAGE_KEY_IMPACT = 'ciq_recent_files'
